import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.TwoFaProfileDisabling.Success', {
    title: 'Two-factor authentication has been disabled.',
    button: 'I understand',
});
